export enum UserRole {
  ADMIN = "ADMIN",
  TRANSLATOR = "TRANSLATOR",
  CONTROLLER = "CONTROLLER",
}
